// ============================================
// HEROSHHI ICONS — drawn for Heroshhi (not a stock icon pack)
// src/components/BrandIcons.jsx
// Style: 24×24, rounded navy lines (follow the text colour) + one gold accent.
//   <BrandIcon name="store" size={20} active />
// "active" is kept for callers; the accent is always full gold (pale gold vanished at menu size).
// ============================================
import React from 'react';

const GOLD = '#F2B12A';

const PATHS = {
  // ⚙️ General — two sliders, gold knobs
  general: (g) => (<>
    <path d="M4 8h16M4 16h16" />
    <circle cx="9" cy="8" r="2.4" fill={g} stroke="currentColor" />
    <circle cx="15.5" cy="16" r="2.4" fill={g} stroke="currentColor" />
  </>),

  // 👥 Team — two people, the front one in gold
  team: (g) => (<>
    <circle cx="15.5" cy="8" r="2.6" />
    <path d="M19.5 18.5c0-2.6-1.8-4.5-4-4.5-.9 0-1.7.3-2.4.8" />
    <circle cx="9" cy="9" r="3" fill={g} fillOpacity=".9" stroke="currentColor" />
    <path d="M3.5 19.5c0-3 2.4-5.3 5.5-5.3s5.5 2.3 5.5 5.3" />
  </>),

  // 📥 Lead sources — tray with a gold arrow dropping in
  sources: (g) => (<>
    <path d="M4 15l1.8-5h12.4l1.8 5v3.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5z" />
    <path d="M4 15h4.5l1 1.8h5l1-1.8H20" />
    <path d="M12 2.5v6.5M9.4 6.6L12 9.2l2.6-2.6" stroke={g} strokeWidth="2" />
  </>),

  // 🎯 Ads & tracking — rising line in a frame, gold peak
  ads: (g) => (<>
    <rect x="3.5" y="4" width="17" height="16" rx="2.5" />
    <path d="M7 15.5l3.2-3.5 2.6 2.2L16.5 9.5" />
    <circle cx="16.8" cy="9.2" r="1.9" fill={g} stroke="currentColor" />
  </>),

  // 🛍️ Store — bag with a gold handle
  store: (g) => (<>
    <path d="M5.5 8.5h13l-1 10.2A1.5 1.5 0 0 1 16 20H8a1.5 1.5 0 0 1-1.5-1.3z" />
    <path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" stroke={g} strokeWidth="2" />
    <path d="M9.5 12.5h5" />
  </>),

  // 🌐 Website chat — browser window with a gold speech bubble
  webchat: (g) => (<>
    <rect x="3" y="4" width="15" height="12" rx="2" />
    <path d="M3 7.5h15" />
    <path d="M13 12.5h7.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H18l-2 1.8v-1.8h-3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z" fill={g} stroke="currentColor" />
  </>),

  // 📜 Activity log — list with a gold clock
  // Instagram — a camera with a gold lens
  instagram: (g) => (<>
    <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
    <circle cx="12" cy="12" r="3.8" fill={g} stroke="currentColor" />
    <circle cx="17" cy="7" r="0.9" fill="currentColor" stroke="none" />
  </>),

  // AI apps — a chat bubble with a gold spark
  ai: (g) => (<>
    <path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8l-4 3v-3H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" />
    <path d="M12 7.6l.95 2.2 2.2.95-2.2.95L12 13.9l-.95-2.2-2.2-.95 2.2-.95z" fill={g} stroke="currentColor" />
  </>),

  activity: (g) => (<>
    <path d="M5 6h9M5 11h6M5 16h5" />
    <circle cx="16.5" cy="15.5" r="4" fill={g} fillOpacity=".9" stroke="currentColor" />
    <path d="M16.5 13.6v2.1l1.4 1" />
  </>),
  // ===== MAIN MENU =====
  // Dashboard — tiles, one gold
  dashboard: (g) => (<>
    <rect x="3.5" y="3.5" width="7" height="9" rx="1.8" />
    <rect x="13.5" y="3.5" width="7" height="5" rx="1.8" fill={g} stroke="currentColor" />
    <rect x="13.5" y="11.5" width="7" height="9" rx="1.8" />
    <rect x="3.5" y="15.5" width="7" height="5" rx="1.8" />
  </>),

  // Leads — a person with a gold "+" badge
  leads: (g) => (<>
    <circle cx="10" cy="8" r="3.5" />
    <path d="M3.5 20c0-3.6 2.9-6.2 6.5-6.2 1.3 0 2.5.3 3.5.9" />
    <circle cx="17.5" cy="17.5" r="3.6" fill={g} stroke="currentColor" />
    <path d="M17.5 15.8v3.4M15.8 17.5h3.4" />
  </>),

  // Messages — chat bubble with gold typing dots
  messages: (g) => (<>
    <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 3.5V17h0A1.5 1.5 0 0 1 4 15.5z" />
    <circle cx="8.5" cy="10.5" r="1.2" fill={g} stroke="none" />
    <circle cx="12" cy="10.5" r="1.2" fill={g} stroke="none" />
    <circle cx="15.5" cy="10.5" r="1.2" fill={g} stroke="none" />
  </>),

  // Reports — bars, the tallest gold
  reports: (g) => (<>
    <path d="M3.5 20.5h17" />
    <rect x="5" y="12" width="3.4" height="6" rx="1" />
    <rect x="10.3" y="8" width="3.4" height="10" rx="1" />
    <rect x="15.6" y="4" width="3.4" height="14" rx="1" fill={g} stroke="currentColor" />
  </>),

  // Quick automations — a loop with a gold bolt inside
  drips: (g) => (<>
    <path d="M19.5 12a7.5 7.5 0 0 1-12.9 5.2M4.5 12A7.5 7.5 0 0 1 17.4 6.8" />
    <path d="M17.6 3.6v3.4h-3.4M6.4 20.4V17h3.4" />
    <path d="M12.8 7.8L10 12.4h3.4l-1.4 3.8" stroke={g} strokeWidth="2" />
  </>),

  // Workflows — three connected steps, one gold
  workflows: (g) => (<>
    <rect x="3.5" y="3.5" width="6" height="5" rx="1.5" />
    <rect x="14.5" y="9.5" width="6" height="5" rx="1.5" fill={g} stroke="currentColor" />
    <rect x="3.5" y="15.5" width="6" height="5" rx="1.5" />
    <path d="M9.5 6h2.5a2 2 0 0 1 2 2v4M14.5 12H12a2 2 0 0 0-2 2v4" />
  </>),

  // Broadcasts — megaphone with gold sound waves
  broadcasts: (g) => (<>
    <path d="M4 10v4a1 1 0 0 0 1 1h2l6 4V5L7 9H5a1 1 0 0 0-1 1z" />
    <path d="M7 15l1 4.5" />
    <path d="M16.5 9.5a3.5 3.5 0 0 1 0 5M19 7a7 7 0 0 1 0 10" stroke={g} strokeWidth="2" />
  </>),

  // Contacts — a contact card with a gold tab
  contacts: (g) => (<>
    <rect x="4" y="3.5" width="14" height="17" rx="2.2" />
    <circle cx="11" cy="10" r="2.6" />
    <path d="M7 16.5c.6-1.9 2.2-3 4-3s3.4 1.1 4 3" />
    <path d="M20.5 7v3M20.5 13v3" stroke={g} strokeWidth="2.2" />
  </>),

  // Appointments — calendar with a gold day
  appointments: (g) => (<>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.2" />
    <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    <rect x="12.5" y="12.5" width="4.5" height="4.5" rx="1.2" fill={g} stroke="currentColor" />
  </>),

  // Orders — a parcel with gold tape
  orders: (g) => (<>
    <path d="M12 3l8 4v10l-8 4-8-4V7z" />
    <path d="M4 7l8 4 8-4M12 11v10" />
    <path d="M8 5l8 4v3.5" stroke={g} strokeWidth="2" />
  </>),

  // Website chats — same as the settings one
  webchats: (g) => PATHS.webchat(g),

  // Fees — a gold coin with ₹
  fees: (g) => (<>
    <circle cx="12" cy="12" r="8.5" fill={g} fillOpacity=".9" stroke="currentColor" />
    <path d="M9 8h6M9 11h6M10 8c3.4 0 3.4 3 0 3h-.5l4.5 5" />
  </>),

  // WhatsApp config — a round chat bubble with a gold check
  'whatsapp-config': (g) => (<>
    <path d="M12 3.5a8.5 8.5 0 0 0-7.3 12.8L3.5 20.5l4.3-1.1A8.5 8.5 0 1 0 12 3.5z" />
    <path d="M8.5 12.2l2.4 2.3 4.6-4.6" stroke={g} strokeWidth="2.2" />
  </>),

  // Support — a lifebuoy with gold segments
  support: (g) => (<>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="3.5" />
    <path d="M6 6l3.5 3.5M18 18l-3.5-3.5M18 6l-3.5 3.5M6 18l3.5-3.5" stroke={g} strokeWidth="2.2" />
  </>),

  // Platform — a shield with a gold star
  platform: (g) => (<>
    <path d="M12 3l7.5 3v5.5c0 4.6-3.2 8-7.5 9.5-4.3-1.5-7.5-4.9-7.5-9.5V6z" />
    <path d="M12 8.3l1.2 2.5 2.7.4-2 1.9.5 2.7L12 14.5l-2.4 1.3.5-2.7-2-1.9 2.7-.4z" fill={g} stroke="currentColor" strokeWidth="1.2" />
  </>),

  // Settings — a gear with a gold centre
  settings: (g) => (<>
    <path d="M10.3 3.5h3.4l.5 2.3 1.6.9 2.2-.8 1.7 2.9-1.8 1.6v1.8l1.8 1.6-1.7 2.9-2.2-.8-1.6.9-.5 2.3h-3.4l-.5-2.3-1.6-.9-2.2.8-1.7-2.9 1.8-1.6v-1.8L4.3 8.8 6 5.9l2.2.8 1.6-.9z" />
    <circle cx="12" cy="12" r="2.8" fill={g} stroke="currentColor" />
  </>)
};


export function BrandIcon({ name, size = 20, active = false, className = '' }) {
  const draw = PATHS[name];
  if (!draw) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      {draw(GOLD)}
    </svg>
  );
}

export const BRAND_ICON_NAMES = Object.keys(PATHS);
export default BrandIcon;